/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import api from '../../../../../../services/api'
import Form, { Input, Select } from '../../../../../../components/Form'
import Button from '../../../../../../components/Button'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../../../../../hooks/toast'
import { useLoading } from '../../../../../../hooks/loading'
import { useUpdateDataTable } from '../../../../../../hooks/dataTable'
import { FormDataProtocol } from '../../domain/protocols'
import { apiCreate, apiUpdate } from '../../domain/api'
import { nameActions } from '../../domain/info'

type IsOpenInModalProps = {
  idParent: number
  handleOnClose: () => void
}

type TypesFormProps = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  valueInput?: object
  isOpenInModal?: false | IsOpenInModalProps
  typeForm:
    | 'create'
    | {
        idUpdate: number
        inputValue: string
        idParentUpdate?: string
      }
}

interface PermissionData {
  name: string
  description: string
  method: string
  base_url: string
  path?: string
}

export const FormCategory = ({
  isOpenInModal,
  typeForm,
  valueInput
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { updateDataTable } = useUpdateDataTable()

  const { activeLoading, disableLoading } = useLoading()

  const onSubmitForm = async (data: FormDataProtocol) => {
    try {
      if (typeForm === 'create') {
        if (isOpenInModal) {
          const { handleOnClose } = isOpenInModal
          const dataCreate: PermissionData = {
            name: data.name,
            description: data.description,
            method: data.method,
            base_url: data.base_url,
            path: data.path?.length ? data.path : null
          }
          activeLoading()
          try {
            await api.post(apiCreate(), dataCreate)
            handleOnClose()
            disableLoading()
            updateDataTable()
            addToast({
              type: 'success',
              title: 'Registro criado',
              description: 'Registro criado com sucesso'
            })
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar a permissão',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            handleOnClose()
            disableLoading()
            updateDataTable()
          }
        } else {
          try {
            const dataCreate: PermissionData = {
              name: data.name,
              description: data.description,
              method: data.method,
              base_url: data.base_url,
              path: data.path?.length ? data.path : null
            }
            activeLoading()
            await api.post(apiCreate(), dataCreate)
            disableLoading()
            updateDataTable()
            addToast({
              type: 'success',
              title: 'Registro criado',
              description: 'Registro criado com sucesso'
            })
            history.push(nameActions.read.to)
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar a permissão',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            disableLoading()
            updateDataTable()
          }
        }
      } else {
        if (isOpenInModal) {
          const { handleOnClose } = isOpenInModal
          const id = typeForm.idUpdate
          const dataUpdate: PermissionData = {
            name: data.name,
            description: data.description,
            method: data.method,
            base_url: data.base_url,
            path: data.path?.length ? data.path : null
          }

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            handleOnClose()
            addToast({
              type: 'success',
              title: 'Permissão atualizado',
              description: 'Permissão alterado com sucesso'
            })
          } catch (error) {
            disableLoading()
            handleOnClose()
            addToast({
              type: 'error',
              title: 'Erro ao atualizar  a permissão',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        } else {
          const dataUpdate: PermissionData = {
            name: data.name,
            description: data.description,
            method: data.method,
            base_url: data.base_url,
            path: data.path?.length ? data.path : null
          }
          const id = typeForm.idUpdate

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            history.push(nameActions.read.to)
            addToast({
              type: 'success',
              title: 'Permissão atualizado',
              description: 'Permissão alterado com sucesso'
            })
          } catch (error) {
            history.push(nameActions.read.to)
            addToast({
              type: 'error',
              title: 'Erro ao atualizar a permissão',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        }
      }
      disableLoading()
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
        if (isOpenInModal) isOpenInModal.handleOnClose()
      }
    }
  }

  return (
    <Form onSubmit={onSubmitForm} defaultValues={valueInput}>
      <>
        <div className="form-body">
          <div className="row">
            <Input
              name="name"
              className="col-3"
              label="Nome"
              rules={{ required: true }}
            />
            <Input
              name="base_url"
              className="col-3"
              label="URL de Base"
              rules={{ required: true }}
            />

            <Input
              name="path"
              className="col-3"
              label="Caminho"
              rules={{ required: false }}
            />

            <Select
              name="method"
              className="col-3"
              label="Método"
              rules={{ required: true }}
              options={[
                {
                  name: 'SELECIONE',
                  value: 'SELECIONE'
                },
                {
                  name: 'GET',
                  value: 'GET'
                },
                {
                  name: 'POST',
                  value: 'POST'
                },
                {
                  name: 'PUT',
                  value: 'PUT'
                },
                {
                  name: 'DELETE',
                  value: 'DELETE'
                },
                {
                  name: 'PATCH',
                  value: 'PATCH'
                }
              ]}
            />
          </div>

          <div className="form-body">
            <div className="row">
              <Input
                name="description"
                className="col-12"
                label="Descrição"
                rules={{ required: true }}
                style={{ minHeight: 100 }}
              />
            </div>
          </div>
        </div>
        {isOpenInModal && typeForm === 'create' ? (
          <hr className="divider" />
        ) : (
          <div style={{ margin: '10px 0' }} />
        )}
        <div className="form-actions right">
          {isOpenInModal && (
            <button
              onClick={isOpenInModal.handleOnClose}
              type="reset"
              className="btn btn-default btn-sm sbold uppercase"
            >
              Fechar
            </button>
          )}
          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <Button type="submit" className="btn btn-primary">
              Salvar
            </Button>
          </div>
        </div>
      </>
    </Form>
  )
}
